import styles from './ConditionsBlock.module.scss';
import parse from 'html-react-parser';

const ConditionsBlock = ({ text }) => {
  return (
    <>
      <div className={styles.conditions_container}>
        <div className={styles.conditions_block}>{parse(text)}</div>
      </div>
    </>
  );
};

export default ConditionsBlock;
